/* eslint-disable react-hooks/set-state-in-effect */
'use client';

import { useState, useEffect } from 'react';
import {
  type EnrollmentStatus,
  isNonProductionEnv,
  getDevEnrollmentOverride,
  setDevEnrollmentOverride,
} from '@/lib/enrollment-config';

const STATUSES: { value: EnrollmentStatus; label: string }[] = [
  { value: 'pre_enrollment', label: 'Pre-Enrollment' },
  { value: 'enrollment_open', label: 'Enrollment Open' },
  { value: 'waitlist_open', label: 'Waitlist Open' },
  { value: 'enrollment_closed', label: 'Enrollment Closed' },
];

/**
 * Dev-only switch to change enrollment status for testing.
 * Only renders in non-production environments.
 */
export function DevEnrollmentSwitch() {
  const [mounted, setMounted] = useState(false);
  const [override, setOverride] = useState<EnrollmentStatus | null>(null);

  useEffect(() => {
    setMounted(true);
    setOverride(getDevEnrollmentOverride());
  }, []);

  // Don't render in production or before hydration
  if (!mounted || !isNonProductionEnv()) {
    return null;
  }

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value as EnrollmentStatus | 'default';
    if (value === 'default') {
      setDevEnrollmentOverride(null);
      setOverride(null);
    } else {
      setDevEnrollmentOverride(value);
      setOverride(value);
    }
    // Reload to apply the change
    window.location.reload();
  };

  return (
    <div className="fixed bottom-4 right-4 rounded-md border bg-white/90 p-2 text-xs shadow-sm backdrop-blur">
      <label className="flex items-center gap-2 text-muted-foreground">
        <span>Enrollment Status:</span>
        <select
          value={override ?? 'default'}
          onChange={handleChange}
          className="rounded border px-1 py-0.5 text-xs"
        >
          <option value="default">Default (env)</option>
          {STATUSES.map((s) => (
            <option key={s.value} value={s.value}>
              {s.label}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
}
